import { OptionalEngagementProps } from '@hcs/types';
export const addOptionalEngagementProps = (props: OptionalEngagementProps) => {
  const {
    dataHcEventName,
    dataHcEventSection,
    dataHcEventType,
    dataHcEventIgnore,
    dataHcEventData,
  } = props;

  return {
    'data-hc-event-name': dataHcEventName,
    'data-hc-event-section': dataHcEventSection,
    'data-hc-event-type': dataHcEventType,
    'data-hc-event-ignore': dataHcEventIgnore,
    'data-hc-event-data': dataHcEventData
      ? typeof dataHcEventData === 'string'
        ? dataHcEventData
        : JSON.stringify(dataHcEventData)
      : undefined,
  };
};
